import {JourneysList} from '@/pages/JourneysList'

export const Home = () => {
  return (
    <div className="mt-5 flex flex-col pt-7">
      <JourneysList />
    </div>
  )
}
